
export default {
  addRatingOnProduct: (productId) => {
    if (typeof $BV === 'undefined') {
      return;
    }
    $BV.configure('global',
      {
        productId
      });

    /*eslint-disable */
        // need to have these, else BV will not work
        $BV.ui('rr', 'show_reviews', {
            doShowContent: () => {

            }
        });

        $BV.ui('qa', 'show_questions', {
            doShowContent: () => {
                // If the container is hidden (such as behind a tab), put code here to make it visible
                // (open the tab).
            }
        });
        /* eslint-enable */
  },

  addInlineRatings: (productIds) => {
    if (typeof $BV === 'undefined') {
      return;
    }

    if (productIds <= 0) {
      return;
    }

    $BV.ui('rr', 'inline_ratings', {
      productIds,
      containerPrefix: 'BVRRInlineRating'
    });
  }
};
